export enum OrganizationType {
    RECYCLER = 'recycler',
    TRUCK = 'truck',
    WASTE_OUTLET = 'waste_outlet',
    CHARITY = 'charity',
}

export const ORGANIZATION_TYPE_LABELS: Record<OrganizationType, string> = {
    [OrganizationType.RECYCLER]: 'Recycler',
    [OrganizationType.TRUCK]: 'Waste Mover',
    [OrganizationType.WASTE_OUTLET]: 'Waste Outlet',
    [OrganizationType.CHARITY]: 'Charity',
};

export function getOrganizationTypeLabel(type: OrganizationType): string {
    return ORGANIZATION_TYPE_LABELS[type] ?? type;
}

/**
 * Site/container operations orgs (branches, pickups, container map).
 * Charity mirrors Waste Outlet without financial features.
 */
export function isSiteOperationsOrgType(type: OrganizationType): boolean {
    return type === OrganizationType.WASTE_OUTLET || type === OrganizationType.CHARITY;
}

export interface OrganizationRequest {
    name: string;
    organization_type: OrganizationType;
    google_maps_url: string;
    data: Record<string, any>;
    logo_asset_id?: string | null;
    logo_filename?: string | null;
}

export interface OrganizationSchema {
    id: string;
    name: string;
    organization_type: OrganizationType;
    google_maps_url: string;
    data: Record<string, any>;
    logo_url: string | null;
    created_at: string;
    updated_at: string;
}

export interface UpdateOrganizationRequest {
    name?: string;
    organization_type?: OrganizationType;
    google_maps_url?: string;
    data?: Record<string, any>;
    logo_asset_id?: string | null;
    logo_filename?: string | null;
}

export interface OrganizationPagination {
    organizations: OrganizationSchema[];
    total: number;
    page: number;
    limit: number;
}

export interface OrganizationQueryParams {
    page?: number;
    limit?: number;
    name?: string | null;
    organization_type?: OrganizationType | null;
}
